import Swipe from 'swipe-js';

export function initUI() {
	const header = document.getElementById('top-header');
	let lastScrollY = window.scrollY;

	window.addEventListener('scroll', () => {
		if (header) {
			if (window.scrollY > lastScrollY && window.scrollY > 100) {
				// Scrolling down
				header.style.transform = 'translateY(-100%)';
			} else {
				// Scrolling up
				header.style.transform = 'translateY(0)';
			}
		}
		lastScrollY = window.scrollY;
	}, { passive: true });

	// Loader
	const ENABLE_LOADER = true; // Toggle this to false for dev server
	const loaderOverlay = document.getElementById('loader-overlay');
	
	if (ENABLE_LOADER && loaderOverlay) {
		const loaderProgress = document.getElementById('loader-progress');
		let loaderFinished = false;
		
		const hideLoader = () => {
			if (loaderFinished) return;
			loaderFinished = true;
			if (loaderProgress) loaderProgress.style.width = '100%';
			setTimeout(() => {
				loaderOverlay.style.opacity = '0';
				setTimeout(() => loaderOverlay.style.display = 'none', 1000);
			}, 400);
		};

		// If there is no scene container (no ThreeJS), hide loader immediately on page load
		if (!document.getElementById('scene-container')) {
			if (document.readyState === 'complete') {
				hideLoader();
			} else {
				window.addEventListener('load', hideLoader);
			}
		}

		window.addEventListener('model-load-progress', (e) => {
			if (loaderFinished) return;
			
			const progress = e.detail;
			if (loaderProgress) loaderProgress.style.width = `${progress}%`;
			
			if (progress >= 100) {
				hideLoader();
			}
		});
	} else if (loaderOverlay) {
		loaderOverlay.style.display = 'none';
	}

	// Testimonials Slider (Bottom)
	const testiSliderEl = document.getElementById('testi-slider');
	const testiDots = document.querySelectorAll('#testi-dots button');
	if (testiSliderEl && testiDots.length > 0) {
		window.testiSlider = new Swipe(testiSliderEl, {
			startSlide: 0,
			speed: 600,
			draggable: true,
			continuous: true,
			disableScroll: false,
			stopPropagation: false,
			callback: function(index) {
				testiDots.forEach((dot, i) => {
					dot.classList.toggle('bg-zinc-500', i === index);
					dot.classList.toggle('bg-white', i !== index);
				});
			}
		});

		testiDots.forEach((dot, i) => {
			dot.addEventListener('click', () => {
				window.testiSlider.slide(i);
			});
		});

		const prevBtn = document.getElementById('testi-prev');
		const nextBtn = document.getElementById('testi-next');
		if (prevBtn) prevBtn.addEventListener('click', () => window.testiSlider.prev());
		if (nextBtn) nextBtn.addEventListener('click', () => window.testiSlider.next());
	}

	// Jobs Slider
	const jobsSliderEl = document.getElementById('jobs-slider');
	const jobsDots = document.querySelectorAll('#jobs-dots button');
	const jobsDetailsLink = document.getElementById('jobs-details-link');
	const jobsSliderBtn = document.getElementById('jobs-slider-btn');

	if (jobsSliderEl) {
		let jobLinks = [];
		try {
			const linksData = jobsSliderEl.getAttribute('data-job-links');
			if (linksData) {
				jobLinks = JSON.parse(linksData);
			}
		} catch (err) {
			console.error('Error parsing job links', err);
		}

		if (jobLinks.length === 0) {
			const slideEls = jobsSliderEl.querySelectorAll('.swipe-wrap > div');
			slideEls.forEach(slide => {
				jobLinks.push(slide.getAttribute('data-job-link') || '#');
			});
		}

		const totalJobs = jobsSliderBtn ? parseInt(jobsSliderBtn.getAttribute('data-total') || '1', 10) : jobLinks.length;
		const textSpan = jobsSliderBtn ? jobsSliderBtn.querySelector('.btn-text') : null;
		const arrowSpan = jobsSliderBtn ? jobsSliderBtn.querySelector('.btn-arrow') : null;

		function updateJobsUI(index) {
			if (jobsDots.length > 0) {
				jobsDots.forEach((dot, i) => {
					dot.classList.toggle('bg-orange-500', i === index);
					dot.classList.toggle('bg-zinc-700', i !== index);
				});
			}

			if (jobsDetailsLink && jobLinks[index]) {
				jobsDetailsLink.href = jobLinks[index];
			}

			if (jobsSliderBtn) {
				if (index === totalJobs - 1) {
					if (textSpan) textSpan.textContent = 'Back to start';
					if (arrowSpan) arrowSpan.innerHTML = '&larr;';
				} else {
					if (textSpan) textSpan.textContent = 'Next';
					if (arrowSpan) arrowSpan.innerHTML = '&rarr;';
				}
			}
		}

		window.jobsSlider = new Swipe(jobsSliderEl, {
			startSlide: 0,
			speed: 500,
			draggable: true,
			continuous: true,
			callback: function(index) {
				updateJobsUI(index);
			}
		});

		if (jobsDots.length > 0) {
			jobsDots.forEach((dot, i) => {
				dot.addEventListener('click', () => window.jobsSlider.slide(i));
			});
		}

		if (jobsSliderBtn) {
			jobsSliderBtn.addEventListener('click', (e) => {
				e.preventDefault();
				if (!window.jobsSlider) return;
				const currentIdx = window.jobsSlider.getPos ? window.jobsSlider.getPos() : 0;
				if (currentIdx === totalJobs - 1) {
					window.jobsSlider.slide(0);
				} else {
					window.jobsSlider.next();
				}
			});
		}
	}

	function initFixedSliderControl(btnId, getSlider) {
		const btn = document.getElementById(btnId);
		if (!btn) return null;
		const total = parseInt(btn.getAttribute('data-total') || '1', 10);
		const textSpan = btn.querySelector('.btn-text');
		const arrowSpan = btn.querySelector('.btn-arrow');

		function update(index) {
			if (index === 0) {
				if (textSpan) textSpan.textContent = 'Hear from our clients';
				if (arrowSpan) arrowSpan.innerHTML = '&rarr;';
			} else if (index === total - 1) {
				if (textSpan) textSpan.textContent = 'Back to Start';
				if (arrowSpan) arrowSpan.innerHTML = '&larr;';
			} else {
				if (textSpan) textSpan.textContent = 'Next';
				if (arrowSpan) arrowSpan.innerHTML = '&rarr;';
			}
		}

		btn.addEventListener('click', (e) => {
			e.preventDefault();
			const slider = getSlider();
			if (!slider) return;
			const currentIdx = slider.getPos ? slider.getPos() : 0;
			if (currentIdx === total - 1) {
				slider.slide(0);
			} else {
				slider.next();
			}
		});

		return update;
	}

	// Capability sliders
	const cap1SliderEl = document.getElementById('cap1-slider');
	if (cap1SliderEl) {
		const updateCap1Btn = initFixedSliderControl('cap1-slider-btn', () => window.cap1Slider);
		window.cap1Slider = new Swipe(cap1SliderEl, {
			draggable: true,
			continuous: true,
			callback: function(index) {
				if (updateCap1Btn) updateCap1Btn(index);
			}
		});
	}

	const cap3SliderEl = document.getElementById('cap3-slider');
	if (cap3SliderEl) {
		const updateCap3Btn = initFixedSliderControl('cap3-slider-btn', () => window.cap3Slider);
		window.cap3Slider = new Swipe(cap3SliderEl, {
			draggable: true,
			continuous: true,
			callback: function(index) {
				if (updateCap3Btn) updateCap3Btn(index);
			}
		});
	}

	// Expertise Tab Sub-sliders
	const cyberSliderEl = document.getElementById('cyber-slider');
	if (cyberSliderEl) {
		const updateCyberBtn = initFixedSliderControl('cyber-slider-btn', () => window.cyberSlider);
		window.cyberSlider = new Swipe(cyberSliderEl, {
			draggable: true,
			continuous: true,
			callback: function(index) {
				if (updateCyberBtn) updateCyberBtn(index);
			}
		});
	}

	const leadershipSliderEl = document.getElementById('leadership-slider');
	if (leadershipSliderEl) {
		const updateLeadershipBtn = initFixedSliderControl('leadership-slider-btn', () => window.leadershipSlider);
		window.leadershipSlider = new Swipe(leadershipSliderEl, {
			draggable: true,
			continuous: true,
			callback: function(index) {
				if (updateLeadershipBtn) updateLeadershipBtn(index);
			}
		});
	}

	const cloudSliderEl = document.getElementById('cloud-slider');
	if (cloudSliderEl) {
		const updateCloudBtn = initFixedSliderControl('cloud-slider-btn', () => window.cloudSlider);
		window.cloudSlider = new Swipe(cloudSliderEl, {
			draggable: true,
			continuous: true,
			callback: function(index) {
				if (updateCloudBtn) updateCloudBtn(index);
			}
		});
	}

	const datacentreSliderEl = document.getElementById('datacentre-slider');
	if (datacentreSliderEl) {
		const updateDatacentreBtn = initFixedSliderControl('datacentre-slider-btn', () => window.datacentreSlider);
		window.datacentreSlider = new Swipe(datacentreSliderEl, {
			draggable: true,
			continuous: true,
			callback: function(index) {
				if (updateDatacentreBtn) updateDatacentreBtn(index);
			}
		});
	}

	// Contact Sidebar Logic
	const openContactBtn = document.getElementById('open-contact-btn');
	const openContactBtnMobile = document.getElementById('open-contact-btn-mobile');
	const openContactBtnFooter = document.getElementById('open-contact-btn-footer');
	const openContactBtnCTAs = document.querySelectorAll('#about-contact-btn, .about-contact-btn');
	const closeContactBtn = document.getElementById('close-contact-btn');
	const contactSidebar = document.getElementById('contact-sidebar');
	const contactOverlay = document.getElementById('contact-overlay');
	const contactForm = document.getElementById('contact-form');
	const formStatus = document.getElementById('contact-form-status');
	const contactNameInput = document.getElementById('name');
	const contactEmailInput = document.getElementById('email');
	const contactMessageInput = document.getElementById('message');

	function toggleContactSidebar(jobTitle = null, jobRef = null, inquiryType = null) {
		if (!contactSidebar || !contactOverlay) return;
		
		const isOpen = !contactSidebar.classList.contains('translate-x-full');
		if (isOpen) {
			contactSidebar.classList.add('translate-x-full');
			contactOverlay.classList.remove('opacity-100');
			setTimeout(() => {
				contactOverlay.classList.add('hidden');
				if (contactForm) {
					contactForm.reset();
					updateUploadFieldsVisibility();
				}
				if (contactNameInput) contactNameInput.setCustomValidity('');
				if (contactEmailInput) contactEmailInput.setCustomValidity('');
				if (contactMessageInput) contactMessageInput.setCustomValidity('');
				if (formStatus) {
					formStatus.classList.add('hidden');
					formStatus.className = 'text-sm py-2 px-3 rounded-md hidden';
					formStatus.textContent = '';
				}
			}, 300);
		} else {
			if (jobTitle && contactMessageInput) {
				let message = `I'm interested in applying for the ${jobTitle}`;
				if (jobRef) {
					message += `, Job Reference #${jobRef}`;
				}
				message += `. Please can you provide more information?`;
				
				contactMessageInput.value = message;
				
				if (inquirySelect) {
					inquirySelect.value = 'job';
					updateUploadFieldsVisibility();
				}
			} else if (inquiryType && inquirySelect) {
				inquirySelect.value = inquiryType;
				updateUploadFieldsVisibility();
			} else if (inquirySelect) {
				inquirySelect.value = '';
				updateUploadFieldsVisibility();
			}
			
			contactOverlay.classList.remove('hidden');
			// Force reflow for opacity transition
			void contactOverlay.offsetWidth;
			contactOverlay.classList.add('opacity-100');
			contactSidebar.classList.remove('translate-x-full');
		}
	}

	if (openContactBtn) openContactBtn.addEventListener('click', (e) => { e.preventDefault(); toggleContactSidebar(); });
	if (openContactBtnMobile) openContactBtnMobile.addEventListener('click', (e) => { 
		e.preventDefault(); 
		window.dispatchEvent(new CustomEvent('context-close-menu'));
		toggleContactSidebar(); 
	});
	if (openContactBtnFooter) openContactBtnFooter.addEventListener('click', (e) => { 
		e.preventDefault(); 
		const inquiryType = openContactBtnFooter.getAttribute('data-inquiry') || 'hire';
		toggleContactSidebar(null, null, inquiryType); 
	});
	openContactBtnCTAs.forEach(btn => btn.addEventListener('click', (e) => { 
		e.preventDefault(); 
		const jobTitle = btn.getAttribute('data-job-title');
		const jobRef = btn.getAttribute('data-job-ref');
		const inquiryType = btn.getAttribute('data-inquiry');
		toggleContactSidebar(jobTitle, jobRef, inquiryType); 
	}));
	if (closeContactBtn) closeContactBtn.addEventListener('click', toggleContactSidebar);
	if (contactOverlay) contactOverlay.addEventListener('click', toggleContactSidebar);

	// Inquiry Type Change Logic
	const inquirySelect = document.getElementById('inquiry');
	const cvUploadContainer = document.getElementById('cv-upload-container');
	const jobDescUploadContainer = document.getElementById('job-desc-upload-container');

	function updateUploadFieldsVisibility() {
		if (!inquirySelect) return;
		const val = inquirySelect.value;
		
		if (cvUploadContainer) {
			if (val === 'job') {
				cvUploadContainer.classList.remove('hidden');
			} else {
				cvUploadContainer.classList.add('hidden');
				const fileInput = cvUploadContainer.querySelector('input[type="file"]');
				if (fileInput) fileInput.value = '';
			}
		}

		if (jobDescUploadContainer) {
			if (val === 'hire') {
				jobDescUploadContainer.classList.remove('hidden');
			} else {
				jobDescUploadContainer.classList.add('hidden');
				const fileInput = jobDescUploadContainer.querySelector('input[type="file"]');
				if (fileInput) fileInput.value = '';
			}
		}

		const messageStar = document.getElementById('message-required-star');
		if (contactMessageInput) {
			if (val === 'job') {
				contactMessageInput.required = false;
				contactMessageInput.setCustomValidity('');
				if (messageStar) messageStar.classList.add('hidden');
			} else {
				contactMessageInput.required = true;
				if (messageStar) messageStar.classList.remove('hidden');
			}
		}
	}

	if (inquirySelect) {
		inquirySelect.addEventListener('change', updateUploadFieldsVisibility);
		updateUploadFieldsVisibility();
	}

	// Contact Form Submission
	const submitText = document.getElementById('contact-submit-text');
	const submitSpinner = document.getElementById('contact-submit-spinner');
	const submitBtn = contactForm ? contactForm.querySelector('button[type="submit"]') : null;

	if (contactForm && formStatus && submitText && submitSpinner && submitBtn) {
		contactForm.addEventListener('submit', (e) => {
			e.preventDefault();
			formStatus.classList.add('hidden');
			formStatus.className = 'text-sm py-2 px-3 rounded-md hidden';
			formStatus.textContent = '';
			submitBtn.disabled = true;
			submitText.textContent = 'Sending...';
			submitSpinner.classList.remove('hidden');

			const formData = new FormData(contactForm);

			fetch('/wp-json/context/v1/contact-submit', {
				method: 'POST',
				body: formData
			})
			.then(response => response.json().then(data => ({ status: response.status, data })))
			.then(({ status, data }) => {
				submitBtn.disabled = false;
				submitText.textContent = 'Send Message';
				submitSpinner.classList.add('hidden');

				if (status === 200 && data.success) {
					formStatus.classList.remove('hidden');
					formStatus.classList.add('bg-green-900/30', 'text-green-400', 'border', 'border-green-800');
					formStatus.textContent = data.message;
					contactForm.reset();
					updateUploadFieldsVisibility();
					setTimeout(() => {
						toggleContactSidebar();
						setTimeout(() => {
							formStatus.classList.add('hidden');
							formStatus.className = 'text-sm py-2 px-3 rounded-md hidden';
							formStatus.textContent = '';
						}, 300);
					}, 2500);
				} else {
					formStatus.classList.remove('hidden');
					formStatus.classList.add('bg-red-900/30', 'text-red-400', 'border', 'border-red-800');
					formStatus.textContent = data.message || 'An error occurred. Please try again.';
				}
			})
			.catch(err => {
				submitBtn.disabled = false;
				submitText.textContent = 'Send Message';
				submitSpinner.classList.add('hidden');
				formStatus.classList.remove('hidden');
				formStatus.classList.add('bg-red-900/30', 'text-red-400', 'border', 'border-red-800');
				formStatus.textContent = 'Network error. Please try again later.';
			});
		});
	}

	// Capability Tabs Vertical Switching
	const triggers = document.querySelectorAll('[data-tab-trigger]');
	const capabilityTrack = document.getElementById('tab-panes-track');
	const tabPanesWrapper = document.getElementById('tab-panes-wrapper');
	
	if (triggers.length > 0 && capabilityTrack && tabPanesWrapper) {
		const panes = capabilityTrack.querySelectorAll('.tab-pane');
		let isSyncing = false;
		let maxCalculatedHeight = 0;

		function syncPanesHeight() {
			if (isSyncing) return maxCalculatedHeight;
			isSyncing = true;

			// Temporarily reset pane heights so natural content height can be measured
			panes.forEach(pane => {
				pane.style.height = '';
				pane.style.minHeight = '';
			});

			let max = 0;
			panes.forEach(pane => {
				// Measure natural pane height
				if (pane.offsetHeight > max) {
					max = pane.offsetHeight;
				}
				// Also inspect all testimonial slides inside this pane so no slide overflows
				const slides = pane.querySelectorAll('.swipe-wrap > div');
				const slider = pane.querySelector('.swipe');
				const sliderBtn = pane.querySelector('button[id$="-slider-btn"]');
				const extra = (sliderBtn ? (sliderBtn.offsetHeight + 24) : 0) + (pane.offsetHeight - (slider ? slider.offsetHeight : 0));
				slides.forEach(slide => {
					const sh = (slide.scrollHeight || slide.offsetHeight) + extra;
					if (sh > max) {
						max = sh;
					}
				});
			});

			if (max > 0) {
				maxCalculatedHeight = max;
				panes.forEach(pane => {
					pane.style.height = `${max}px`;
				});
				tabPanesWrapper.style.height = `${max}px`;
			}

			// Keep active pane correctly positioned
			const activeIndex = parseInt(capabilityTrack.dataset.activeTabIndex || '0', 10);
			if (panes[activeIndex]) {
				capabilityTrack.style.transform = `translateY(-${panes[activeIndex].offsetTop}px)`;
			}

			requestAnimationFrame(() => {
				isSyncing = false;
			});

			return maxCalculatedHeight;
		}

		function updateCapabilityTab(index, animate = true) {
			if (!panes[index]) return;
			const activePane = panes[index];

			if (!animate) {
				tabPanesWrapper.style.transition = 'none';
				capabilityTrack.style.transition = 'none';
			} else {
				tabPanesWrapper.style.transition = 'height 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
				capabilityTrack.style.transition = 'transform 0.5s cubic-bezier(0.4, 0, 0.2, 1)';
			}

			if (maxCalculatedHeight > 0) {
				tabPanesWrapper.style.height = `${maxCalculatedHeight}px`;
			}

			capabilityTrack.style.transform = `translateY(-${activePane.offsetTop}px)`;
			capabilityTrack.dataset.activeTabIndex = index;

			if (!animate) {
				void tabPanesWrapper.offsetHeight;
				tabPanesWrapper.style.transition = '';
				capabilityTrack.style.transition = '';
			}
		}

		triggers.forEach((trigger, index) => {
			trigger.addEventListener('click', function() {
				triggers.forEach(t => {
					t.classList.remove('text-orange-500', 'bg-orange-950/20', 'border-orange-500/20');
					t.classList.add('text-zinc-500', 'hover:text-zinc-300', 'hover:bg-zinc-900/50', 'border-transparent');
					const arrow = t.querySelector('.tab-arrow');
					if (arrow) {
						arrow.classList.remove('opacity-100');
						arrow.classList.add('opacity-0');
					}
				});
				
				this.classList.add('text-orange-500', 'bg-orange-950/20', 'border-orange-500/20');
				this.classList.remove('text-zinc-500', 'hover:text-zinc-300', 'hover:bg-zinc-900/50', 'border-transparent');
				const arrow = this.querySelector('.tab-arrow');
				if (arrow) {
					arrow.classList.remove('opacity-0');
					arrow.classList.add('opacity-100');
				}
				
				// Reset all internal horizontal sliders
				if (window.cyberSlider) window.cyberSlider.slide(0);
				if (window.leadershipSlider) window.leadershipSlider.slide(0);
				if (window.cloudSlider) window.cloudSlider.slide(0);
				if (window.datacentreSlider) window.datacentreSlider.slide(0);

				updateCapabilityTab(index, true);

				const sliders = [window.cyberSlider, window.leadershipSlider, window.cloudSlider, window.datacentreSlider];
				if (sliders[index] && typeof sliders[index].setup === 'function') {
					sliders[index].setup();
				}

				const jobsDotsList = document.querySelectorAll('#jobs-dots button');
				if (jobsDotsList.length > 0) {
					jobsDotsList.forEach((dot, i) => {
						dot.classList.toggle('bg-orange-500', i === 0);
						dot.classList.toggle('bg-zinc-700', i !== 0);
					});
				}
			});
		});

		// Initial setup
		syncPanesHeight();
		updateCapabilityTab(0, false);

		// Window resize listener
		let resizeTimeout;
		window.addEventListener('resize', () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => {
				syncPanesHeight();
				const activeIndex = parseInt(capabilityTrack.dataset.activeTabIndex || '0', 10);
				updateCapabilityTab(activeIndex, false);
			}, 100);
		});

		// ResizeObserver to adjust height if fonts or content change
		if (window.ResizeObserver) {
			const ro = new ResizeObserver(() => {
				if (!isSyncing) {
					syncPanesHeight();
				}
			});
			panes.forEach(pane => ro.observe(pane));
		}

		if (document.fonts && document.fonts.ready) {
			document.fonts.ready.then(() => {
				syncPanesHeight();
				const activeIndex = parseInt(capabilityTrack.dataset.activeTabIndex || '0', 10);
				updateCapabilityTab(activeIndex, false);
			});
		}

		// Also sync after full page load (images, assets)
		window.addEventListener('load', () => {
			syncPanesHeight();
			const activeIndex = parseInt(capabilityTrack.dataset.activeTabIndex || '0', 10);
			updateCapabilityTab(activeIndex, false);
		});
	}

	// Timesheets Sidebar Logic
	const openTimesheetsBtn = document.getElementById('open-timesheets-btn');
	const openTimesheetsBtnMobile = document.getElementById('open-timesheets-btn-mobile');
	const closeTimesheetsBtn = document.getElementById('close-timesheets-btn');
	const timesheetsSidebar = document.getElementById('timesheets-sidebar');
	const timesheetsOverlay = document.getElementById('timesheets-overlay');
	const timesheetsForm = document.getElementById('timesheets-form');
	const tsStatus = document.getElementById('timesheets-form-status');
	const tsSubmitText = document.getElementById('timesheets-submit-text');
	const tsEmailInput = document.getElementById('ts-username');
	const tsPasswordInput = document.getElementById('ts-password');

	function toggleTimesheetsSidebar() {
		if (!timesheetsSidebar || !timesheetsOverlay) return;
		
		const isOpen = !timesheetsSidebar.classList.contains('translate-x-full');
		if (isOpen) {
			timesheetsSidebar.classList.add('translate-x-full');
			timesheetsOverlay.classList.remove('opacity-100');
			setTimeout(() => {
				timesheetsOverlay.classList.add('hidden');
				if (timesheetsForm) timesheetsForm.reset();
				if (tsStatus) {
					tsStatus.classList.add('hidden');
					tsStatus.className = 'text-sm py-2 px-3 rounded-md hidden';
					tsStatus.textContent = '';
				}
			}, 300);
		} else {
			timesheetsOverlay.classList.remove('hidden');
			void timesheetsOverlay.offsetWidth;
			timesheetsOverlay.classList.add('opacity-100');
			timesheetsSidebar.classList.remove('translate-x-full');
		}
	}

	if (openTimesheetsBtn) openTimesheetsBtn.addEventListener('click', (e) => { e.preventDefault(); toggleTimesheetsSidebar(); });
	if (openTimesheetsBtnMobile) openTimesheetsBtnMobile.addEventListener('click', (e) => { 
		e.preventDefault(); 
		window.dispatchEvent(new CustomEvent('context-close-menu'));
		toggleTimesheetsSidebar(); 
	});
	if (closeTimesheetsBtn) closeTimesheetsBtn.addEventListener('click', toggleTimesheetsSidebar);
	if (timesheetsOverlay) timesheetsOverlay.addEventListener('click', toggleTimesheetsSidebar);

	if (timesheetsForm && tsStatus && tsSubmitText) {
		timesheetsForm.addEventListener('submit', (e) => {
			e.preventDefault();
			tsStatus.classList.add('hidden');
			tsStatus.className = 'text-sm py-2 px-3 rounded-md hidden';
			tsStatus.textContent = '';
			tsSubmitText.textContent = 'Signing you in';
			let dotsCount = 0;
			const dotsInterval = setInterval(() => {
				dotsCount = (dotsCount + 1) % 4;
				tsSubmitText.textContent = 'Signing you in' + '.'.repeat(dotsCount);
			}, 400);

			setTimeout(() => {
				clearInterval(dotsInterval);
				tsStatus.classList.remove('hidden');
				tsStatus.classList.add('bg-red-900/30', 'text-red-400', 'border', 'border-red-800');
				tsStatus.textContent = 'Invalid credentials. Please try again.';
				tsSubmitText.textContent = 'Log In';
			}, 3000);
		});
	}

	const tsResetPasswordBtn = document.getElementById('ts-reset-password-btn');
	if (tsResetPasswordBtn && tsStatus && tsEmailInput) {
		tsResetPasswordBtn.addEventListener('click', (e) => {
			e.preventDefault();
			if (!tsEmailInput.checkValidity()) {
				tsEmailInput.reportValidity();
				return;
			}
			tsStatus.classList.remove('hidden', 'bg-red-900/30', 'text-red-400', 'border-red-800');
			tsStatus.classList.add('bg-green-900/30', 'text-green-400', 'border', 'border-green-800');
			tsStatus.textContent = "If you're registered for Context Timesheets, we've sent a password reset link to your email.";
		});
	}
}